export interface ModalSliceInitType {
    warningModal: {
        isOpen: boolean;
        text: string;
    };
    confirmModal: {
        isOpen: boolean;
        title: string;
        contents: string;
        cancelButtonContents: string;
        onClickCancelButton: () => void;
        confirmButtonContents: string;
        onClickConfirmButton: () => void;
    };
    progressModal: boolean;
}

export const initialState: ModalSliceInitType = {
    warningModal: {
        isOpen: false,
        text: '',
    },
    confirmModal: {
        isOpen: false,
        title: '',
        contents: '',
        cancelButtonContents: '취소',
        confirmButtonContents: '확인',
        onClickCancelButton: null,
        onClickConfirmButton: null,
    },
    progressModal: false,
};
